import BigNumber from "bignumber.js";

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
});

export const BSC_BLOCK_TIME = 3;

export const dev = () => {
  if (
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENV === "prod"
  ) {
    return false;
  }
  return false;
};

export const config = {
  DIAMOND_HAND: dev()
    ? "0x38cC9c6cdAdd77733FB052d3dF1bAC37790cDca1"
    : "0x3D1AB551Ed4C9e13Eb96adb6b054d8487e081b20",
  SAPP_ADDRESS: dev()
    ? "0x77fDdfB3c526B9dfD3CE15f0359F98D0dcce5b0f"
    : "0x097f8ae21e81d4f248a2e2d18543c6b3cc0d8e59",
  SAPP_DECIMALS: dev() ? 18 : 18,
  AVERAGE_BLOCK_TIME_IN_SEC: 3,
  BSC_CHAIN_ID: dev() ? 97 : 56,
  ETH_CHAIN_ID: dev() ? 4 : 1,
};

export const TIME_FORMAT = {
  DATE_FORMAT: "YYYY-MM-DD",
  DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm:ss Z",
  TIME_FORMAT: "HH:mm:ss",
};
